import React from 'react';

import { BlogCategoryType } from '@utils/types/blog';
import Button from '@components/_shared/button';

import styles from './styles.module.scss';
import Link from 'next/link';
import BlogList from '@components/blog/blogList';
import ImageWithLoader from '@components/_shared/imageWithLoader';

type Props = {
  category: BlogCategoryType;
};

const BlogCategory = (props: Props) => {
  const {
    category: {
      slug: { current: slug },
      title,
      relatedBlogs,
      highlightedBlog,
    },
  } = props;

  if (!relatedBlogs?.length) return null;

  return (
    <div className={styles.categoryBlock} key={`category-${slug}`}>
      {highlightedBlog && (
        <div className={styles.highlightedBlog}>
          <div className={styles.highlightedBlog__textBlock}>
            <div className={styles.highlightedBlog__title}>
              {highlightedBlog.title}
            </div>
            <div className={styles.highlightedBlog__excerpt}>
              {highlightedBlog.excerpt}
            </div>
            <Button
              containerStyle={styles.highlightedBlog__buttonContainer}
              variant="blueContained"
              to={`/blog/${highlightedBlog.slug?.current}`}
            >
              Read More
            </Button>
          </div>

          <ImageWithLoader
            containerStyle={styles.highlightedBlog__image}
            src={highlightedBlog.image}
            alt={highlightedBlog.title}
            sizes="(max-width: 1024px) 100vw,
                       50vw"
          />
        </div>
      )}

      <div className={styles.categoryBlock__header}>
        <h2 className={styles.categoryBlock__title}>{title}</h2>
        {relatedBlogs.length > 3 && (
          <Link href={`/blog/category/${slug}`}>
            <a>
              <div className={styles.categoryBlock__viewAll}>
                {`View All Articles (${relatedBlogs.length})`}
              </div>
            </a>
          </Link>
        )}
      </div>

      <BlogList
        blogs={relatedBlogs.slice(0, 3)}
        containerStyle={styles.categoryBlock__relatedBlogs}
      />
    </div>
  );
};

export default BlogCategory;
